import { WppTypography } from '@wppopen/components-library-react'
import clsx from 'clsx'
import { ReactElement } from 'react'
import type { KeyObjectType } from 'reducers/KeywordsAndPhrasesReducer/KeywordsAndPhrasesReducer.d'
import styles from '../HighlightedSpan.module.scss'

type HighlightedPhraseChildren = string | ReactElement<HighlightedPhraseProps>
export type HighlightingState = 'active' | 'inactive' | 'disabled'

interface HighlightedPhraseProps {
  // allow for nested keywords/phrases
  children: HighlightedPhraseChildren | HighlightedPhraseChildren[]
  highlightingState: HighlightingState
  highlightingType: KeyObjectType
  isNested?: boolean
}

function HighlightedTextBodySpan({ children, highlightingState, highlightingType, isNested }: HighlightedPhraseProps) {
  return (
    <>
      {isNested && ' '}
      <WppTypography
        type="s-midi"
        tag="span"
        className={clsx(
          styles[highlightingType],
          highlightingState && styles[`--${highlightingState}`],
          isNested && styles['--nested'],
        )}
        data-testid={highlightingType}
      >
        {children}
      </WppTypography>
      {isNested && ' '}
    </>
  )
}

export default HighlightedTextBodySpan
